module.exports = __webpack_public_path__ + "img/aboutkec2.3617bcf6.jpg";